import {h, Component} from 'preact';
import {connect} from 'react-redux';
import reduce from '../reducers';
import * as actions from '../actions';
import Spinner from './Spinner';
import {createPortal} from "preact/compat";
import store from '../store';
import FreeProFlag from './FreeProFlag';
import designService from "../service/designService";
import Renderer, {renderDesign} from "../canvas/renderer";
import constants from "../constants";
import util from "../util";
import designDomain from "../domain/designDomain";
import {initDesignInStore} from "../service/storeService";
import menuObject from '../canvas/menu-object';

const QUICK = true;

class UseTemplateModal extends Component {
  constructor() {
    super();

    this.use = this.use.bind(this);

    this.state = {
      isLoading: false,
      hasError: false
    }
  }

  updateTemplate() {
    designService.quickUpdateDesignTemplate(this.props.designId, this.props.design.id, this.props.locationId).then(resp => {
      const design = new designDomain.Design(resp.data);

      initDesignInStore(design)
      renderDesign(design, {isMobile: store.getState().isMobileVersion});

      store.dispatch(actions.setWebsiteToken(""));
      this.cleanUpSEOFields();
      window.data.design.qrCodeId = "";

      if (window.history) {
        window.history.replaceState({}, '', `${constants.appPrefix}/design?id=${design.id}`);
      }

      util.nextTick(() => {
        menuObject.fixDefaultIconColor();
      })

      this.setState({isLoading: false});
      this.props.onModalClose();

      if (store.getState().isMobileVersion) {
        store.dispatch(actions.setIsMobileAside(false));
      }
    }).catch((err) => {
      this.setState({
        isLoading: false,
        hasError: true
      });
      util.nextTick(() => {
        this.setState({hasError: false});
      }, 3000)
    });
  }

  cleanUpSEOFields() {
    store.dispatch(actions.setShareLink(null));
    store.dispatch(actions.updateElementAttribute('seoRestaurantName', ''));
    store.dispatch(actions.updateElementAttribute('seoMenuAdjective', ''));
    store.dispatch(actions.updateElementAttribute('seoFoodType', ''));
    store.dispatch(actions.updateElementAttribute('seoCity', ''));
    store.dispatch(actions.updateElementAttribute('seoState', ''));
    store.dispatch(actions.updateElementAttribute('seoShareLinkError', ''));
    store.dispatch(actions.updateElementAttribute('seoExampleTitle', ''));
    store.dispatch(actions.updateElementAttribute('seoExampleText', ''));
  }

  quickUse() {
    this.setState({isLoading: true});
    const hasChanges = store.getState().hasChanges;
    if (!hasChanges) {
      this.updateTemplate();
    } else {
      designService.updateDesignHtml({
        id: store.getState().designId,
        html: Renderer.getPagesContent(),
        lastSavedTag: store.getState().lastSavedTag,
        hasChanges: false,
        hasVideo: store.getState().hasVideo
      }).then(() => {
        this.updateTemplate();
      });
    }
  }

  use() {
    if (QUICK) {
      this.quickUse();
      return;
    }
    let location = constants.appPrefix + '/design?parentId=' + this.props.design.id;
    if (!this.props.hasChanges) {
      location += '&delete=' + this.props.designId;
    }
    this.props.setShowExitWarning(false);
    window.location = location;
  }

  initModal($preview, $previewImage) {
    const $modal = $('.modal.use-template');
    if (!store.getState().isMobileVersion) {
      let imgWidth = $previewImage.css('width');
      let modWidth = parseInt(imgWidth) > 0 ? (700 + parseInt(imgWidth)).toString() + 'px' : '1100px';
      $modal.css('width', modWidth);
      let modHeight = `${160 + parseInt($previewImage.css('height'))}px`;
      $modal.css({'height': modHeight, 'max-height': '80vh'});
      $modal.hide();
      $modal.css('opacity', 1);
      setTimeout(function () {
        $modal.show();
      }, 100);
    } else {
      let imgHeight = $previewImage.css('height');
      $modal.css('height', 'calc(206px + ' + imgHeight + ')');
      $preview.css('height', imgHeight);
      $modal.hide();
      $modal.css('opacity', 1);
      setTimeout(function () {
        $modal.show();
      }, 100);
    }
  }

  render(props, state) {
    let imgPath = '';
    if (props.design && props.design.name) {
      imgPath = props.design.defaultThumbnailPath.replace('-w300', '-w500');
    }

    const $preview = $('.preview');
    const $previewImage = $preview.children('img').first();

    $previewImage.on('load', () => this.initModal($preview, $previewImage));
    $previewImage.on('error', () => this.initModal($preview, $previewImage));

    return props.open ? createPortal(<div>
      <div className="modal-back" onClick={props.onModalClose}></div>
      <div className={'modal use-template'}>
        <div className="content">

          {props.design &&
          <div className={'preview'}>
            <FreeProFlag free={props.design.free} isFreemium={props.isFreemium}/>
            <img src={imgPath} alt={props.design.name}/>
          </div>}

          <div className={'data'}>
            <h3>Start a new template?</h3>
            <p>Any changes made to your current design will be saved</p>

            {!state.isLoading && <footer>
              <a className="btn decline" onClick={props.onModalClose}>Cancel</a>
              <a className="btn primary accept" onClick={this.use}>Ok</a>
              {state.hasError && <p style={{color: '#e32737'}}>We experienced some issues loading this template.</p>}
            </footer>}

            {state.isLoading && <footer>
              <Spinner />
            </footer>}
          </div>
        </div>
      </div>
    </div>, document.getElementById('modals')) : null;
  }
}

export default connect(reduce, actions)(UseTemplateModal);
